export default "__VITE_ASSET__58fd1d98__"